import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';

import image4 from "../../Assets/Img/image4.png"
import image3 from "../../Assets/Img/image3.png"
import image5 from "../../Assets/Img/image5.png"
import "./Header.scss"
import { Link } from 'react-router-dom';
import BirinchiIkkinchi from '../../Pages/Birinchi_ikkinchi/Birinchi_ikkinchi';
import Yuklangan from '../Yuklanganlar/Yuklangan';
const Header = () => {
  const uquvchi = [
    {
      id:1,
      materialName: "Yuz Mumtoz Faylasuf",
      author: "Saida Jo'rayeva",
      file: "pdf",
      photo: "https://kitobxon.com/img_knigi/4205.jpg",
      file_name: "/yuriy_trifonov.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:2,
      materialName: "o'tkan kunlar 1-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/01_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:3,
      materialName: "O'tkan kunlar 2-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/02_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:4,
      materialName: "O'tkan kunlar 4-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/04_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:5,
      materialName: "60 yoshda san'atning nurli yo'li",
      author: "Farg'ona kolleki",
      file: "mp3",
      photo: "/image/nurli_yul.jpg",
      file_name: "60_yoshda_sanatning_nurli_yoli.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:6,
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "../abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:7,
      materialName: "Yana Bahor hokim",
      author: "Zulfiya",
      file: "mp3",
      photo: "",
      file_name: "../zulfiya_yana_bahor_hokim.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:8,
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:9,
      materialName: "Torga Tashrif",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "../zulfiya_torga_tashrif.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:10,
      materialName: "Tong",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "../zulfiya_tong.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:11,
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:12,
      materialName: "zhek_london_martin_iden",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zhek_london_martin_iden.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:13,
      materialName: "mirmuhsin_xozhand_qalsi",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mirmuhsin_xozhand_qalsi_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:14,
      materialName: "mixail_lermantov_zamonamiz",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mixail_lermantov_zamonamiz_qahramoni_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:15,
      materialName: "muxammad_ali_sarbadorlar",
      author: "2-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/muxammad_ali_sarbadorlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:16,
      materialName: "muxammad_ali_sarbadorlar",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/muxammad_ali_sarbadorlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:17,
      materialName: "odil_yoqubov_ulugbek",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/odil_yoqubov_ulugbek_hazinasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:18,
      materialName: "onta_negr_bolasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/onta_negr_bolasi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:19,
      materialName: "orzularingiz_ogirlanishiga",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/orzularingiz_ogirlanishiga_jol_qojmang..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:20,
      materialName: "otkir_hoshimov_tushda",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/otkir_hoshimov_tushda_kechgan_umirlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:21,
      materialName: "pirimqul_qodirov_humoyun",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    
  ]
  const arxiv = [
    {
      id: 1,
      materialName: "Yuz Mumtoz Faylasuf  w",
      author: "Saida Jo'rayeva",
      file: "pdf",
      photo: "https://kitobxon.com/img_knigi/4205.jpg",
      file_name: "/BaliqchilikAsoslari.pdf",
      roll: ['student'],
      categories: ['student']
    },

    {
      id: 2,
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "/abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },

    {
      id: 3,
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },


    {
      id: 4,
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:5,
      materialName: "tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik__har_bir_rahbar_faoliyatining_kundalik_qoidasi_bolishi_kerak.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:6,
      materialName: "usmon_azim._sajlanma_",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/usmon_azim._sajlanma_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:7,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:8,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:9,
      materialName: "yodgor",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/yodgor.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:10,
      materialName: "yulduzli_tunlar",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/yulduzli_tunlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:11,
      materialName: "zaxarli_hayot_yohud_ishq__qurbonlari.",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/zaxarli_hayot_yohud_ishq__qurbonlari..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:12,
      materialName: "zhek_london_martin_iden",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/zhek_london_martin_iden.pdf",
      roll: ['student'],
      categories: ['student']
    },    {
      id:13,
      materialName: "tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik__har_bir_rahbar_faoliyatining_kundalik_qoidasi_bolishi_kerak.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:14,
      materialName: "usmon_azim._sajlanma_",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/usmon_azim._sajlanma_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:15,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
  ]
  const app = [
    {
      id: 1,
      materialName: "Photoshop",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Photoshop.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 2,
      materialName: "PotPlayer",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/PotPlayer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 3,
      materialName: "Rufus 2.6",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Rufus2.6.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 4,
      materialName: "Total Commander Power Pack8.0.1x86",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/TotalCommanderPowerPack8.0.1x86.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 5,
      materialName: "UltraISO",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/UltraISO.exe",
      roll: ['student'],
      categories: ['public']
    },

  ]
  const [student, setStudent] = useState(uquvchi)
  console.log(student);
  return (
    <div>
      <div className='header' style={{ display: "flex", justifyContent: "center", margin: "40px auto" }}>
        <h1>Mening malumotlarim!</h1>
        <div className='header__render'>
          <Link to="/BirinchiIkkinchi" className='card'>
            <img className='card__img' src={image4} alt="" />
            <h2>{student.length}</h2>
            <h4>1-2-3-4 kurs materiallari</h4>
          </Link>
          <Link to="/Arxiv" className='card'>
            <img className='card__img' src={image3} alt="" />
            <h2>{arxiv.length}</h2>
            <h4>Raqamli arxiv</h4>
          </Link>
          <Link to="/StudentApp" className='card'>
            <img className='card__img' src={image5} alt="" />
            <h2>{app.length}</h2>
            <h4>Dasturiy ta'minot</h4>
          </Link>
        </div>
      </div>
      <Yuklangan/>
    </div>
  );
}

export default Header;
